import React, { useCallback, useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { usePdvOnline } from '~/pages/PdvOnline/hooks/usePdvOnline';
import { getSaldoCaixa } from '~/pages/PdvOnline/services/getSaldoCaixa';
import { moneyFormat } from '~/utils/functions';
import { TableCell } from '../../style';
import { Content, Dot, HiddenValueWrapper, Spinner } from './style';

interface CellSaldo {
  value: string | number;
}

export const CellSaldo: React.FC<CellSaldo> = ({ value }) => {
  const { initialStatePdv, handleSaldoPdv, handleInitialStatePdv } =
    usePdvOnline();
  const [visibleBalance, setVisibleBalance] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClickOff = useCallback(async () => {
    setVisibleBalance(!visibleBalance);

    if (!initialStatePdv) return;

    setLoading(true);

    const { saldo } = await getSaldoCaixa(
      Number(initialStatePdv.cod_operador),
      Number(initialStatePdv.num_pdv),
      Number(initialStatePdv.cod_loja),
    );

    handleInitialStatePdv({
      ...initialStatePdv,
      val_saldo: saldo,
    });

    handleSaldoPdv(moneyFormat(saldo.toString()));

    setLoading(false);
  }, [handleSaldoPdv, initialStatePdv, visibleBalance, handleInitialStatePdv]);

  return (
    <TableCell>
      <Content>
        <span style={{ visibility: visibleBalance ? 'visible' : 'hidden' }}>
          {loading && '0,00'}
          {!loading &&
            (value === '' || !value || value === 0 || value === '0'
              ? '0,00'
              : value)}
        </span>
        <HiddenValueWrapper
          style={{ visibility: visibleBalance ? 'hidden' : 'visible' }}
        >
          {[1, 2, 3, 4].map((index) => (
            <Dot key={index} />
          ))}
        </HiddenValueWrapper>
        {visibleBalance && !loading && (
          <FiEye
            onClick={() => setVisibleBalance(!visibleBalance)}
            aria-label={`mudar visibilidade para ${
              visibleBalance ? 'falso' : 'verdadeiro'
            }`}
            className="icone"
          />
        )}
        {loading && <Spinner className="icone" />}
        {!visibleBalance && !loading && (
          <FiEyeOff
            onClick={handleClickOff}
            aria-label={`mudar visibilidade para ${
              visibleBalance ? 'falso' : 'verdadeiro'
            }`}
            className="icone"
          />
        )}
      </Content>
    </TableCell>
  );
};
